module.exports = __webpack_public_path__ + "media/Macchione_PolodelGusto_2021_def.e21373e9.webm";